import { ALIGN_CLASSES as e } from "../../constants.js";
import { defineAttrs as t } from "../../utils/typed-attrs.js";
import { centerable as n } from "../decorators/centerable.js";
import { uploadable as r } from "../decorators/uploadable.js";
import "../decorators.js";
var i = n(r({
	inline: !0,
	draggable: !0,
	attrs: t({
		type: { default: "inlineImage" },
		src: { default: "" },
		linkUrl: { default: "" },
		width: { default: "" },
		displayWidth: { default: "" },
		height: { default: "" },
		text: { default: "" },
		className: { default: "" }
	}),
	group: "inline",
	parseDOM: [{
		tag: ".intercom-inline-image",
		priority: 60,
		getAttrs(e) {
			let t = e;
			return {
				src: t.getAttribute("src"),
				text: t.getAttribute("alt"),
				width: e.getAttribute("data-width") || e.style.width.replace("px", ""),
				className: e.getAttribute("data-class-name") ?? ""
			};
		}
	}, {
		tag: "img[src]",
		getAttrs(e) {
			return {
				src: e.getAttribute("src"),
				linkUrl: e.getAttribute("data-link-url"),
				width: e.getAttribute("data-width") || e.style.width.replace("px", ""),
				height: e.getAttribute("data-height"),
				text: e.getAttribute("alt"),
				className: e.getAttribute("data-class-name") ?? ""
			};
		}
	}],
	toDOM(t) {
		let n = t.attrs, { src: r, width: i, height: a, text: o, className: s } = n, { displayWidth: c } = n;
		return c ||= i, ["img", {
			src: r,
			alt: o,
			class: `${e[n.alignment]} intercom-inline-image`,
			style: `width: ${c}px;`,
			"data-link-url": n.linkUrl,
			"data-height": a,
			"data-width": i,
			"data-class-name": s
		}];
	}
}));
//#endregion
export { i as inlineImageSpec };
